export default __webpack_public_path__ + "static/media/agrola_logo.2b2d97c7.svg";